import { defaultPresentationTypographyPicks, presentationTypographyOptions } from './create-presentation-option'

export function makePicks(
  type: 'heading1' | 'heading2' | 'heading3' | 'body',
  field: 'fontSize' | 'fontWeight' | 'letterSpacing' | 'lineHeight' | 'textTransform'
) {
  return presentationTypographyOptions[type][`${field}Options`][defaultPresentationTypographyPicks[type][field]]
}
